import React, { useState } from "react";
import { toast } from "react-toastify";
import { Card, Button, Chip } from "../ui";
import { Calendar, Support } from "../icons";
import { formatDueDate } from "../../lib/learning";
import { getVoiceLaunchUrl } from "../../services/VoiceTrainingService";

export const VoiceTrainingCard = ({ item }) => {
  const [starting, setStarting] = useState(false);
  const overdue = !item.attempts && item.dueDate && new Date(item.dueDate) < new Date();

  const start = async () => {
    setStarting(true);
    try {
      const url = await getVoiceLaunchUrl(item.assignmentId);
      if (!url) throw new Error("Voice training is unavailable right now.");
      window.location.assign(url);
    } catch (e) {
      toast.error(e.message);
      setStarting(false);
    }
  };

  return (
    <Card accent="success" className="ds-stack">
      <div style={{ padding: "var(--s-4) var(--s-5) var(--s-5)", display: "flex", flexDirection: "column", flex: 1 }}>
        <div className="ds-row-flex ds-between ds-gap-2">
          <Chip>Voice practice</Chip>
          {item.attempts > 0 && (
            <Chip tone="success">
              {item.attempts} attempt{item.attempts === 1 ? "" : "s"}
              {typeof item.bestScore === "number" ? ` · best ${item.bestScore.toFixed(1)}/${item.scoreMax || 5}` : ""}
            </Chip>
          )}
        </div>

        <h3 className="ds-h3 ds-mt-3" style={{ lineHeight: 1.4 }}>
          {item.scenarioTitle || "Sales voice training"}
        </h3>

        <p
          className="ds-sub ds-row-flex ds-gap-2"
          style={{
            marginTop: 8,
            color: overdue ? "var(--danger-ink)" : undefined,
            fontWeight: overdue ? 600 : undefined,
          }}
        >
          <Calendar size={14} />
          {item.dueDate
            ? `${overdue ? "Overdue — was due" : "Due"} ${formatDueDate(item.dueDate)}`
            : "No due date"}
        </p>

        <div style={{ marginTop: "auto", paddingTop: "var(--s-4)" }}>
          <Button
            variant={item.attempts > 0 ? "outline" : "primary"}
            icon={Support}
            block
            disabled={starting}
            onClick={start}
          >
            {starting ? "Opening…" : item.attempts > 0 ? "Practise again" : "Start voice training"}
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default VoiceTrainingCard;
